import helpers from '../commonHelpers/helpers'

import { IRegistrationTabs } from '../models/event-registered-users/event-registered-users.interface'
import { IEventFees } from '../models/event-fees/event-fees.interface'
import { IEventReviewPublish } from '../models/event-review-publish/event-review-publish.interface'
import {
  competitorEventRegisterHelper,
  ICompetitorEventRegisterTypes,
} from '../pages/competitor/competitorEventRegister/competitorEventRegisterHelper'

import { FEES_CATEGORY_CONST } from '../components/events/views/details/EventDetailsViewComponentFees'

export const getFeesTabData = (publishedEventInDb: IEventReviewPublish | null) => {
  let available = 0
  let isExtraFees = false
  let feesItem: any = null
  let availabilityExists: boolean = false
  let feesTabData: IRegistrationTabs['IFeesTab'][] = []
  let keyofFeesItemKeyName: keyof IEventFees | null = null
  let feesItem_: ICompetitorEventRegisterTypes['IEvaluatedFeeItem'] | null = null

  if (!publishedEventInDb) {
    console.error('error: publishedEventInDb is null')
    return []
  }

  try {
    const { emptyVarName, emptyVarValue } = helpers.findEmptyVal({
      publishedEventInDb,
      EventFees: publishedEventInDb?.EventFees || null,
    })

    if (emptyVarName) {
      console.error('error:', `${emptyVarName} is [${emptyVarValue}]`)
      return []
    }

    const { EventFees } = publishedEventInDb

    feesTabData = Object.keys(EventFees).reduce(
      (acc, feesItemKeyName) => {
        feesItem_ = null
        isExtraFees = false
        keyofFeesItemKeyName = feesItemKeyName as any

        if (!keyofFeesItemKeyName) return acc

        feesItem = EventFees[keyofFeesItemKeyName]

        if (!feesItem) return acc
        if (feesItem && typeof feesItem === 'object' && !Array.isArray(feesItem))
          feesItem_ = competitorEventRegisterHelper.getEvaluatedFeeItem(feesItem)
        else if (feesItem && Array.isArray(feesItem)) isExtraFees = true

        if (!feesItem) return acc

        if (isExtraFees) {
          feesItem.forEach((currentExtraFees: any) => {
            feesItem_ = null
            availabilityExists = false
            feesItem_ = competitorEventRegisterHelper.getEvaluatedFeeItem(currentExtraFees)

            if (!feesItem_) return acc

            availabilityExists = (feesItem_?.available ?? 0) > 0
            available = availabilityExists ? feesItem_.available : 0

            if (available < 0) available = 0

            acc.push({
              registrationFees: null,
              feesCategory: feesItem_.category,
              feesDescription: feesItem_.note,
              feesPrice: feesItem_.cost,
              feesItemId: feesItem_.uuid,
              available: available,
              feesTitle: feesItem_.name,
              feesDuration: feesItem_.duration,
            })
          })
        } else if (feesItem_ && feesItem.category !== 'refund') {
          if (Object.values(FEES_CATEGORY_CONST).includes(feesItem_.category)) {
            availabilityExists = (feesItem_?.available ?? 0) > 0
            available = availabilityExists ? feesItem_.available : 0

            if (available < 0) available = 0

            if (FEES_CATEGORY_CONST.GOVERNANCE === feesItem_?.category) {
              feesItem_.duration =
                FEES_CATEGORY_CONST.GOVERNANCE === feesItem_.category
                  ? 'Per horse'
                  : feesItem_.duration
            }

            acc.push({
              registrationFees: null,
              feesCategory: feesItem_.category,
              feesDescription: feesItem_.note,
              feesPrice: feesItem_.cost,
              feesItemId: feesItem_.uuid,
              available: available,
              feesTitle: feesItem_.name,
              feesDuration: feesItem_.duration,
            })
          }
        }

        return acc
      },
      [] as IRegistrationTabs['IFeesTab'][]
    )
    return feesTabData
  } catch (error) {
    console.error('error: ', error)
    return []
  }
}
